import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f87017c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f87017c8&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f87017c8&prod&lang=scss&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=f87017c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87017c8",
  null
  
)

export default component.exports